'use client';
import { FC, MouseEvent } from 'react';

import { useAppRouter } from '@contexts/router';
import { useClearDispatch } from '@contexts/auth/AuthContext';
import { removeBasketDetailsOnLocalStorage } from '@utils/removeBasketDetailsOnLocalStorage';
import { callService } from '@api/caller';
import { removeCsoLoginParamsOnLocalStorage } from '@utils/removeCsoLoginParamsOnLocalStorage';

import { StyledLink } from './styled';

interface IUserMenuLink {
  label: string;
  href: string;
}

const UserMenuLink: FC<IUserMenuLink> = ({ label, href }) => {
  const { push } = useAppRouter();
  const clearUserInformation = useClearDispatch();

  const handleClick = async (e: MouseEvent<HTMLAnchorElement>) => {
    if (href === '/logout') {
      e.preventDefault();

      /**
       * Call logout service
       */
      try {
        await callService('AuthenticationService', 'logout');
      } catch (error) {
        console.error(error);
      }

      /**
       * Clear user information from context
       */
      clearUserInformation();

      /**
       * Remove basket details from local storage when user logs out
       */
      removeBasketDetailsOnLocalStorage();

      /**
       * Remove cso login params from local storage when user logs out
       */
      removeCsoLoginParamsOnLocalStorage();

      /**
       * Redirect to home page
       */
      push('/');
      return false;
    }

    return true;
  };

  return (
    <StyledLink prefetch={false} href={href} onClick={handleClick}>
      {label}
    </StyledLink>
  );
};

export default UserMenuLink;
